<template>
  <div>
    <div class="form-group">
      <label for="">Nombre</label>
      <input type="text" class="form-control" v-model="name" maxlength="255" />
    </div>
    <div class="form-group">
      <label for="">Celular/Teléfono</label>
      <input type="text" class="form-control" v-model="cell_phone_number" />
    </div>
  </div>
</template>
<script>
export default {
  components: {
    //
  },

  // directives
  // filters

  props: {
    //
  },

  data: () => ({
    name: "",
    cell_phone_number: "",
    birthdate: null,
    idcard_type_id: 1,
    idcard: "00000"
  }),

  computed: {
    //
  },

  watch: {
    //
  },

  mounted() {
    //
  },

  methods: {
    getData() {
      return this.$data;
    },
    reset() {
        this.name = ""
        this.cell_phone_number = ""
        this.birthdate = null
        this.idcard_type_id = 1
        this.idcard = "00000"
    },
  }
};
</script>

<style></style>
